export default function isTextEmpty(json) {
    if (!json) {
        return true;
    }
    if (json.hasOwnProperty('content') && !(json === null || json === void 0 ? void 0 : json.content)) {
        return true;
    }
    if (json.hasOwnProperty('content') && json.content.length === 1 && json.content[0].type === 'paragraph' && !json.content[0].content) {
        return true;
    }
    if (json === null || json === void 0 ? void 0 : json.html) {
        var _json_html, _json_html1;
        if (((_json_html = json.html) === null || _json_html === void 0 ? void 0 : _json_html.features) && /"isEmpty":true/.test((_json_html1 = json.html) === null || _json_html1 === void 0 ? void 0 : _json_html1.features)) {
            return true;
        }
    }
    return false;
}

//# sourceMappingURL=isEmpty.js.map